var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.125 4.25H3.54167H14.875",
    stroke: "#37495F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4596 4.25008V14.1667C13.4596 14.5425 13.3104 14.9028 13.0447 15.1685C12.779 15.4342 12.4187 15.5834 12.043 15.5834H4.95964C4.58391 15.5834 4.22358 15.4342 3.9579 15.1685C3.69222 14.9028 3.54297 14.5425 3.54297 14.1667V4.25008M5.66797 4.25008V2.83341C5.66797 2.45769 5.81722 2.09736 6.0829 1.83168C6.34858 1.566 6.70891 1.41675 7.08464 1.41675H9.91797C10.2937 1.41675 10.654 1.566 10.9197 1.83168C11.1854 2.09736 11.3346 2.45769 11.3346 2.83341V4.25008",
    stroke: "#37495F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.cc4c14d37e2c20c43e34fc8f5f780d84.svg";
export { ForwardRef as ReactComponent };